export type AgeAssuranceGateState = 'pending' | 'allowed' | 'blocked';

export type AgeAssuranceAttemptTrigger = 'startup' | 'retry';

export enum AgeAssuranceMode {
  OFF = 'off',
  LIVE = 'live',
  QA_TEXAS_LIVE = 'qa-texas-live',
  QA_OUTSIDE_TEXAS = 'qa-outside-texas',
  QA_UNDER_13 = 'qa-under-13',
  QA_13_PLUS = 'qa-13-plus',
  QA_UNAVAILABLE = 'qa-unavailable',
}

export type AgeAssuranceNativeResult =
  | 'not_called'
  | 'android_access_not_shared'
  | 'android_verification_required'
  | 'android_access_unavailable'
  | 'response_missing'
  | 'response_under_threshold'
  | 'response_at_or_above_threshold'
  | 'response_ambiguous'
  | 'response_invalid'
  | 'error_not_available'
  | 'error_user_declined'
  | 'error_invalid_request'
  | 'error_no_view_controller'
  | 'android_error_api_not_available'
  | 'android_error_play_store_not_found'
  | 'android_error_network'
  | 'android_error_play_services_not_found'
  | 'android_error_cannot_bind_to_service'
  | 'android_error_play_store_version_outdated'
  | 'android_error_play_services_version_outdated'
  | 'android_error_client_transient'
  | 'android_error_app_not_owned'
  | 'android_error_sdk_version_outdated'
  | 'android_error_internal'
  | 'error_unknown';

export type AgeAssuranceOutcome =
  | 'flag_disabled'
  | 'web_bypass'
  | 'geography_unavailable'
  | 'outside_texas'
  | 'android_access_not_shared'
  | 'android_verification_required'
  | 'native_unavailable'
  | 'native_failure'
  | 'age_13_plus'
  | 'age_under_13';

export type UserGeo = {
  country?: unknown;
  state?: unknown;
};

export type AgeRangeBounds = {
  lowerBound?: unknown;
  upperBound?: unknown;
};

export type PlatformAgeAssuranceResult =
  | ({ outcome: 'age_range' } & AgeRangeBounds)
  | {
      outcome:
        | 'android_access_not_shared'
        | 'android_verification_required'
        | 'native_unavailable'
        | 'native_failure';
      nativeResult: AgeAssuranceNativeResult;
    };

export type AgeAssuranceTerminalEvent = {
  message: 'Age assurance decision completed';
  ageAssuranceOutcome: AgeAssuranceOutcome;
  ageAssuranceTrigger: AgeAssuranceAttemptTrigger;
  ageAssuranceNativeResult: AgeAssuranceNativeResult;
};

export type AgeAssuranceTelemetryEvent = AgeAssuranceTerminalEvent & {
  ageAssuranceMode: AgeAssuranceMode;
};

export type AgeAssuranceAttemptDependencies = {
  queryUserGeo: () => Promise<UserGeo | null>;
  requestPlatformAgeAssurance: () => Promise<PlatformAgeAssuranceResult>;
  logTerminalDecision: (event: AgeAssuranceTerminalEvent) => void;
};
